import { List as ListComponent } from 'antd';

const List = props => <ListComponent {...props} />;

export default List;
